module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ahand5-27ca1cae88429b7c1b1f1397ce38370d.jpg";